// extracted by mini-css-extract-plugin
export var dateLabel = "_3f-0";
export var dateLabelError = "_3f-1";
export var fullWidth = "_3f-2";
export var smaller = "_3f-3";